// This file is generated.
export var version = '2.0.4';
//# sourceMappingURL=version.js.map